import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import useId from 'hooks/useId';
import VS from "constants/ValidationShema";
import Loading from "components/Loading";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import PartsTable from "components/PartsTable";
import {connect} from "react-redux";
import BoldTypography from "components/BoldTypography";
import useSnackbar from "hooks/useSnackbar";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {PurchasingGroupStageSections} from "../../../../constants/PurchasingGroupStageSections";

function AddPurchasingGroupMemberPopup(
    {
        groupId,
        onClose,
        formSubmit,
    }) {

    const [working, setWorking] = useState(false);
    const [membersList, setMembersList] = useState(null);
    const {enqueueSuccessSnackbar} = useSnackbar();
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    useEffect(() => {
        PurchasingGroupStage1Service.getMembersAvailableConcerns(groupId).then((resp) => {
            const respMapped = resp.map(x => ({identity: x.orgId, name: x.name}));
            setMembersList(respMapped);
        }).catch(() => onClose());
        // eslint-disable-next-line
    }, [])


    const onSubmit = ({concerns}) => {
        const selectedOrgs = Object.keys(concerns).filter(key => !!concerns[key])

        setWorking(true);
        PurchasingGroupStage1Service.addMembers(groupId, selectedOrgs).then((resp) => {
            enqueueSuccessSnackbar(Tr('purchase_group_members_added', {x: resp.length}))
            PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.MEMBERS)
            onClose();
        }).catch(() => {
            setWorking(false);
        })
    }

    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('confirm'), handleSubmit, undefined, working || !membersList || membersList.length === 0, undefined, working));
        return <MultiButton buttons={buttons}/>;
    }

    return (
        <Dialog
            title={Tr("purchase_group_member_add")}
            open={true}
            dialogActions={getActions()}
        >
            {
                !membersList ? <Loading/> :
                    <Form
                        initialValues={{
                            concerns: membersList.reduce((prev, cur) => {
                                prev[cur.identity] = false;
                                return prev;
                            }, {}),
                        }}
                        validationSchema={
                            VS.object({
                                concerns: VS.any().test('partSelected', Tr('choose_at_least_one'), (e) => {
                                    const selected = Object.keys(e).filter(x => e[x] === true).length;
                                    return selected > 0;
                                })
                            })
                        }
                        onSubmit={onSubmit}
                        id={formId}
                    >
                        {(formikProps) => (
                            membersList.length === 0 ?
                                <BoldTypography>{Tr('purchase_group_member_add_no_concerns')}</BoldTypography>
                                :
                                <PartsTable
                                    label={Tr('purchase_group_member_add_label')}
                                    id="concerns"
                                    formikProps={formikProps}
                                    elementList={membersList}
                                    disabled={working}
                                />)}
                    </Form>
            }

        </Dialog>
    )
}

AddPurchasingGroupMemberPopup.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired
};

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddPurchasingGroupMemberPopup);